var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.6067L13.3958 10.0012L19.9976 3.39695L16.6042 0L9.9988 6.60425L3.39455 0L0 3.39695L6.60185 10.0012L0 16.6055L3.39695 20L9.9988 13.3958L16.6006 20L20 16.6067Z",
    fill: "#CC2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossmark);
export default __webpack_public_path__ + "static/media/Cross mark.b1fcdfe7ac8ad6ef2cfba92c2769e66b.svg";
export { ForwardRef as ReactComponent };